export default __webpack_public_path__ + "static/media/CV-Migues.c195ef22.jpg";